export default __webpack_public_path__ + "static/media/proofreaderSlide.c56d92cf.png";